import React, { memo, useEffect, useState } from 'react'
import { css } from '@emotion/css'
import { useTbViewStore } from '@vt/hooks'
import useAmap from '../hooks/use-amap/use-cluster-area'

const Info = memo(({ area = {} }) => {
  return (
    <div className="p-3">
      <div
        className={css`
          display: grid;
          grid-template-columns: auto 200px;
          gap: 10px;
        `}
      >
        <span>地块信息</span>
        <span />
        <span className="text-right">地块编号：</span>
        <span>{area.lotNumber || area.tableDataId}</span>
        <span className="text-right">点位：</span>
        <span>{area.label}</span>
      </div>
    </div>
  )
})

const Massif = () => {
  const [area, setArea] = useState()
  const { lnglat } = useTbViewStore((state) => state.clickedInfo)
  const { InfoWindow, getAmap } = useAmap('viewmap', {
    showMarker: false,
    onPolygonClick: setArea,
    center: lnglat,
    areaFields: ['lotNumber', 'tableDataId', 'label'],
  })

  useEffect(() => {
    const amap = getAmap()
    if (amap && lnglat) {
      amap.setCenter(lnglat)
    }
  }, [lnglat])
  return (
    <div className="w-full h-full relative">
      <div id="viewmap" className="w-full h-full" />
      <InfoWindow>
        <Info area={area} />
      </InfoWindow>
    </div>
  )
}

export default memo(Massif)
